import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'main [app-unauthorized]',
  templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
